<template>
  <a-layout-content :style="{ padding: '0 24px', minHeight: '280px' }" v-if="isAuthenticated">
    <a-row :gutter="[48, 16]">
      <a-col :span="12">
        <a-card :bordered="false">
          <template #title>
            {{ t("homepage.welcome") }}
            {{ isAuthenticated === true ? username : "" }}!
          </template>
          <p>{{ t("homepage.hint.action") }}</p>
          <a-menu theme="light">
            <a-menu-item key="llm">
              <router-link class="nav-text" to="/llm">
                <PartitionOutlined :style="{ fontSize: '24px' }" />
                {{ t("homepage.menu.llm") }}
              </router-link>
            </a-menu-item>

            <a-menu-item key="website-check">
              <router-link class="nav-text" to="/websitecheck">
                <CheckCircleOutlined :style="{ fontSize: '24px' }" />
                {{ t("homepage.menu.websitecheck") }}
              </router-link>
            </a-menu-item>
            <a-menu-item key="settings">
              <router-link class="nav-text" to="/settings">
                <SettingOutlined :style="{ fontSize: '24px' }" />
                {{ t("homepage.menu.settings") }}
              </router-link>
            </a-menu-item>
          </a-menu>
        </a-card>
      </a-col>
      <a-col :span="12">
        <a-card :title="t('homepage.header.help')" :bordered="false">
          <ContactForm />
        </a-card>
      </a-col>
    </a-row>

    <a-row :gutter="[48, 16]">
      <a-col :span="12">
        <a-card :title="t('homepage.header.usage')" :bordered="false">
          <a-row>
            <a-col v-for="item of statistics.items" :key="item.label" :span="8">
              <a-statistic :title="item.label" :value="item.value" style="margin-right: 10px" />
            </a-col>
          </a-row>
        </a-card>
      </a-col>
      <a-col :span="12">
        <a-card :title="t('homepage.header.faq')" :bordered="false">
          <a-collapse v-model:activeKey="activeKey">
            <a-collapse-panel :key="index.toString()" v-for="(item, index) of items" :header="item.question">
              <p :style="{ whiteSpace: 'pre-line' }">{{ item.answer }}</p>
            </a-collapse-panel>
          </a-collapse>
        </a-card>
      </a-col>
    </a-row>
    <a-layout-footer style="text-align: center; padding: 8px 50px; background-color: #fff">Jaasper 2016-{{ new Date().getFullYear() }} Alle Rechte vorbehalten. </a-layout-footer>
  </a-layout-content>
  <a-layout-content :style="{ padding: '0 24px', minHeight: '480px' }" v-else>
    <a-row>
      <a-col :span="12" :offset="6">
        <a-card>
          <login-form
            ><template v-slot:message> <a-alert message="Error" description="Unable to login. Please check your credentials" type="error" /> </template
          ></login-form>
        </a-card>
      </a-col>
    </a-row>
    <a-layout-footer style="text-align: center; padding: 8px 50px; background-color: #fff">Jaasper 2016-{{ new Date().getFullYear() }} Alle Rechte vorbehalten. </a-layout-footer>
  </a-layout-content>
</template>

<script lang="ts">
import { ref, defineComponent, computed, watch, reactive } from "vue";
import { useI18n } from "vue-i18n";
import { ScanOutlined, SearchOutlined, PartitionOutlined, SettingOutlined, CheckCircleOutlined } from "@ant-design/icons-vue";
import { items } from "../utils/constants/faqItems";
import OCRIcon from "./icons/OCR.vue";
import TrainIcon from "./icons/Train.vue";
import ContactForm from "./ContactForm.vue";
import LoginForm from "./LoginForm.vue";
import { getOverviewReport } from "../api/documentReport";
import { isAuthorized } from "../service/authorization";
import { useUserStore } from "../store/modules/user";
export default defineComponent({
  name: "Homepage",
  components: {
    ScanOutlined,
    SearchOutlined,
    SettingOutlined,
    CheckCircleOutlined,
    PartitionOutlined,
    OCRIcon,
    ContactForm,
    LoginForm,
    TrainIcon,
  },
  setup: () => {
    const store = useUserStore();
    const { t } = useI18n();
    const activeKey = ref<string[]>([""]);
    const isAuthenticated = computed(() => store.isAuthenticated);
    const username = computed(() => store.getProfile.username);
    const overwriteItemName = (name: string) => {
      switch (name) {
        case "ocr":
          return t("navigation.ocr");
        case "doc":
          return t("navigation.documents");
        case "web":
          return t("navigation.websitecheck");
        case "netz":
          return "NetzBeweis";
        default:
          return name;
      }
    };
    const statistics = reactive({
      items: [] as { label: string; value: number; actualValue: number }[],
    });
    const updateCounters = () => {
      let foundIncomplete = false;
      const statTypes = Object.keys(statistics);
      for (const stat of statistics.items) {
        if (stat.value !== stat.actualValue) {
          stat.value += 1;
          foundIncomplete = true;
        }
      }
      if (foundIncomplete) {
        setTimeout(() => updateCounters(), 50);
      }
    };

    const generateStatistics = async () => {
      if (!isAuthorized("SEE_DOCUMENT_REPORT")) {
        return;
      }
      const overviewReport = await getOverviewReport();
      let reversed = overviewReport.reverse();
      for (const item of reversed) {
        const counterFrom = item.countTotal > 100 ? item.countTotal - 100 : item.countTotal;
        statistics.items.push({ label: overwriteItemName(item.itemType), actualValue: item.countTotal, value: counterFrom });
      }

      updateCounters();
    };

    watch(
      () => isAuthenticated.value,
      () => {
        if (isAuthenticated.value === true) {
          generateStatistics();
        }
      }
    );
    if (isAuthenticated.value === true) {
      generateStatistics();
    }
    return { isAuthenticated, statistics, username, items, activeKey, t };
  },
});
</script>

<style scoped>
a {
  color: #42b983;
}
</style>
